import { Box, Button, IconButton } from "@origin-digital/ods-core";
import { IconPlus } from "@origin-digital/ods-icons";
import React, { useEffect, useState } from "react";
import { Field, useFormikContext } from "formik";
import AutocompleteField from "./AutocompleteField";
import { DraftIcon } from "src/components/Projects/Icons";
import { Contact, ElectricityBlockValues } from "../types";
import { apiClient } from "src/api/apiService";
import FormContext from "src/context/FormContext";
import AddContactASP from "./AddContactASP";
import { useResponsiveBelowSm } from "src/hooks";

interface IContactFieldProps {
  contactType: "ELECTRICIAN" | "SERVICE_PROVIDER";
  name: "licensedElectrician" | "asp";
  label: string;
}

const removePrefix = (str: string) => str.replace("IH#", "").replace("FSP", "");

const ContactFieldASP: React.FC<IContactFieldProps> = ({
  contactType,
  name,
  label,
}) => {
  const {
    formState: { msaNumber },
  } = React.useContext(FormContext);
  const [loading, setLoading] = useState<boolean>(false);
  const { values, setFieldValue } = useFormikContext<ElectricityBlockValues>();
  const [open, setOpen] = useState(false);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const isBelowSm = useResponsiveBelowSm();

  const closeDialog = () => {
    setOpen(false);
  };
  const openDialog = () => {
    setOpen(true);
  };

  const fetchContacts = async () => {
    setLoading(true);
    try {
      // Fetch contacts
      const response = await apiClient.get<Contact[]>(`/contact/${msaNumber}`, {
        params: { type: contactType, meter_provider: values.meterProvider },
      });
      setContacts(
        response.data.map((contact) => ({
          ...contact,
          license_number: removePrefix(contact.license_number),
        }))
      );
      setLoading(false);
    } catch (error) {
      console.log(`Fetch contacts error: ${error}`);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, [values.meterProvider, msaNumber, contactType]);

  return (
    <>
      <Box display="flex" alignItems="flex-start" justifyContent="flex-start">
        <Field
          component={AutocompleteField}
          name={name}
          label={label}
          options={contacts.map((contact) => ({
            label: `${contact.first_name} ${contact.last_name}`,
            value: contact.id,
          }))}
          loading={loading}
        />
        {/* Add or Edit button */}
        <Box marginTop="xxsmall">
          {isBelowSm ? (
            <IconButton onClick={openDialog}>
              {values?.[name] ? <DraftIcon /> : <IconPlus color="critical" />}
            </IconButton>
          ) : (
            <>
              {values?.[name] ? (
                <Button
                  variant="text"
                  icon={<DraftIcon color="inherit" />}
                  onClick={openDialog}
                >
                  Edit
                </Button>
              ) : (
                <Button
                  variant="text"
                  icon={<IconPlus color="inherit" />}
                  onClick={openDialog}
                >
                  Add
                </Button>
              )}
            </>
          )}
        </Box>
      </Box>
      {open && (
        <AddContactASP
          closeDialog={closeDialog}
          selectedContact={contacts.find((e) => e.id === values?.[name])}
          fetchContacts={fetchContacts}
          setFieldValue={setFieldValue}
          name={name}
          label={label.toLowerCase()}
          contactType={contactType}
          meterProvider={values.meterProvider}
        />
      )}
    </>
  );
};
export default ContactFieldASP;
